import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesInformation } from '../../getProcedureInformation/actions';
import ExamnStragglesRepository from '@/domain/repositories/ExamStragglesRepository';
import ExamsStragglesDataRepository from '@/data/repositories/ExamStragglesDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    const {
      procedureId,
      courseCatalog,
      courseId,
      period,
      assessmentType,
      assessmentTypeDesc,
      courseDescription,
      requirePayment,
      numberClass,
      turn,
      startDate
    } = action.data;

    yield put({ type: Types.REGISTER_LATE_COURSES_REQUEST });
    XCheckpointManager.registerStart('Examen de rezagados - register');

    const examStragglesRepository: ExamnStragglesRepository =
      new ExamsStragglesDataRepository();

    const examSstragglesResponse = yield call(
      examStragglesRepository.registerLateCourses,
      {
        procedureId,
        courseCatalog,
        courseId,
        period,
        assessmentType,
        assessmentTypeDesc,
        courseDescription,
        requirePayment,
        numberClass,
        turn,
        startDate
      }
    );

    if (!examSstragglesResponse || examSstragglesResponse?.error) {
      yield put({
        type: Types.REGISTER_LATE_COURSES_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }

    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });

    yield put({
      type: Types.REGISTER_LATE_COURSES_SUCCESS,
      data: examSstragglesResponse.requestId
    });
    XCheckpointManager.registerEnd('Examen de rezagados - register');
  } catch (error) {
    yield put({
      type: Types.REGISTER_LATE_COURSES_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
